import { Component, OnInit, OnDestroy, NgZone, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material';
import { ISubscription } from 'rxjs/Subscription';
import { SearchEditionResults, SearchEditionResultRow } from '../../../models/search-edition-results';
import { SearchEditionParams, SectionKey, RESULTS_LIMIT, RESULTS_SECTION_LABELS, EDITION_SECTIONS } from '../../../models/search-edition-params';
import { SearchEditionService } from '../../../services/search-edition.service';
import { globals } from '../../../../globals';

@Component({
    selector: 'app-search-edition-results',
    templateUrl: './search-edition-results.component.html',
    styleUrls: ['./search-edition-results.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SearchEditionResultsComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    searchResults: SearchEditionResults;
    searchAllResults: SearchEditionResults;
    searchParams: SearchEditionParams;
    loading = false;
    loadingImage = globals.html_small_loading_gif;
    resultsSectionLabels = RESULTS_SECTION_LABELS;
    editionSections = EDITION_SECTIONS;

    /* Paginator properties */
    resultCount: number;
    resultPageIndex: number;
    resultPageSize: number;
    resultPageSizeOptions: Array<number>;

    constructor(
        private router: Router,
        private zone: NgZone,
        private searchEditionService: SearchEditionService
    ) {
        this.initPaginator();
    }

    private initPaginator() {
        this.resultCount = 0;
        this.resultPageIndex = 0;
        this.resultPageSize = RESULTS_LIMIT;
        this.resultPageSizeOptions = [RESULTS_LIMIT, RESULTS_LIMIT * 2, RESULTS_LIMIT * 3];
    }

    ngOnInit() {
        this.subscriptions.push(
            this.searchEditionService.getSearchParams().subscribe(
                params => {
                    if (params) {
                        this.searchParams = params;
                        this.resultPageIndex = this.searchParams.pagination.page - 1;
                    }
                }
            ),
            this.searchEditionService.isSearchInProgress().subscribe(
                searchInProgress => this.loading = searchInProgress
            ),
            this.searchEditionService.getSearchAllResults().subscribe(
                results => {
                    if (results) {
                        this.searchAllResults = results.filter(result => result.total > 0);
                    }
                }
            ),
            this.searchEditionService.getSearchResults().subscribe(
                results => {
                    if (results) {
                        this.searchResults = results;
                        if (this.searchResults.length > 0) {
                            this.resultCount = this.searchResults[0].total;
                            if (this.searchParams) {
                                this.searchEditionService.cachePageResults(
                                    this.searchParams.section,
                                    this.searchParams.pagination.page,
                                    this.searchResults
                                );
                            }
                        } else {
                            this.initPaginator();
                        }
                    }
                }
            )
        );
    }

    getSearchResults(pageEvent?: PageEvent) {
        if (pageEvent) {
            this.resultPageIndex = pageEvent.pageIndex;
            this.searchParams.pagination.page = pageEvent.pageIndex + 1;
            /* Reset session cache if page size is changed */
            if (pageEvent.pageSize !== this.searchParams.pagination.limit) {
                this.searchEditionService.resetSearchResultsCache();
                this.searchParams.pagination.limit = pageEvent.pageSize;
                this.resultPageSize = pageEvent.pageSize;
            }

            this.loadCachedSearchResults();
        }
    }

    viewResultsInEdition(resultRow: SearchEditionResultRow) {
        this.searchEditionService.setSearchEditionSelected(resultRow);
        this.zone.run(() => this.router.navigate(['/edition/' + resultRow.doc + '/text']));
    }

    searchInSection(section: SectionKey) {
        this.searchEditionService.resetSearchEditionSelected();
        this.searchParams.resetPagination();
        this.searchParams.section = section;
        this.loadCachedSearchResults();
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

    private loadCachedSearchResults() {
        const cachedResults = this.searchEditionService.getCachedSearchResultsByPage(
            this.searchParams.section,
            this.searchParams.pagination.page
        );
        if (cachedResults) {
            this.searchResults = cachedResults;
            this.resultCount = this.searchResults[0].total;
            this.searchEditionService.updateSearchParams(this.searchParams);
        } else {
            this.searchEditionService.updateSearchResults(this.searchParams);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/search-edition-results/search-edition-results.component.ts